import React from "react";
import Account from "../../common/account";
import { getCoOwnerProfile, updateCoOwnerProfile } from "../../../services/co-owner.service";

interface Props {
  coOwnerId: string;
}

const CoOwnerAccount: React.FC<Props> = ({ coOwnerId }) => {
  return (
    <Account
      userId={coOwnerId}
      getProfile={getCoOwnerProfile}
      updateProfile={updateCoOwnerProfile}
      title="Your Profile"
      subtitle="Keep your details up to date"
    />
  );
};

export default CoOwnerAccount;
